import { gql } from 'graphql.macro';

export const RemoveSheqManager = gql`
  mutation removeSHEQManager($managerEmployeeId: Int!) {
    removeSHEQManager(managerEmployeeId: $managerEmployeeId)
  }
`;